const useGaEventTracking = () => {

    const trackEvent = (category:any, action:any, label:any, items:any) => {

        if (window.gtag) {
            const { value, currency, transaction_id, items: ecommerceItems, ...customParams } = items;

            window.gtag('event', action, {
                event_category: category,
                event_label: label,
                value: value,
                currency: currency,
                transaction_id: transaction_id,
                items: ecommerceItems,
                ...customParams,
            });
        }
    };

    return trackEvent;
};

export default useGaEventTracking;